import React, { useState } from "react";
import "./Card.css";
import { useCart } from "../../Modules/Hooks/useCart";
import Modal from "../Modal/Modal";
import VariantSelector from "./VariantSelector";
import Image from "../Image/Image";

const Card = ({ title, description, image, variants, product, compact }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const minPrice = Math.min(...variants.map((v) => v.price));

  const cardContainerClass = product.is_stop_list
    ? `Card--Container stop-list${compact ? " Card--Container--compact" : ""}`
    : `Card--Container${compact ? " Card--Container--compact" : ""}`;

  const handleSelectClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <div
        onClick={() => !product.is_stop_list && setIsModalOpen(true)}
        className={cardContainerClass}
      >
        <div className="Card--ImageWrapper">
          <Image src={image} alt={title} className="Card--Image" />
          {compact && product.is_stop_list && (
            <div className="Card--Badge">Нет</div>
          )}
        </div>
        <div className="Card--Content">
          <h3 className="Card--Title">{title}</h3>
          {!compact && <p className="Card--Description">{description}</p>}
          <div className="Card--Footer">
            <span className="Card--Price">от {minPrice} ₽</span>
            {!compact &&
              (product.is_stop_list ? (
                <span className="Card--OutOfStock">Нет в наличии</span>
              ) : (
                <button
                  className="Card--SelectButton"
                  onClick={handleSelectClick}
                >
                  Выбрать
                </button>
              ))}
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <VariantSelector
          product={product}
          variants={variants}
          onClose={() => setIsModalOpen(false)}
        />
      </Modal>
    </>
  );
};
export default Card;
